/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M6.546.984a.5.5 0 01.908 0L9.14 4.64a.5.5 0 00.395.287l3.997.474a.5.5 0 01.28.864l-2.954 2.733a.5.5 0 00-.151.464l.784 3.948a.5.5 0 01-.735.534l-3.512-1.966a.5.5 0 00-.488 0l-3.512 1.966a.5.5 0 01-.735-.534l.784-3.948a.5.5 0 00-.15-.464L.186 6.264A.5.5 0 01.468 5.4l3.997-.474a.5.5 0 00.395-.287L6.546.984z"/>'
  }
})
